import { } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { MarketoObjectDataset } from 'app/model/dataset/marketo.dataset';
import { TabularCopySource } from './tabular-type.copysource';

@Metamodel.model({
    name: 'MarketoSource',
    display: [],
    tags: { datasetModel: Metamodel.modelFor(MarketoObjectDataset) }
})
export class MarketoCopySource extends TabularCopySource {
}
